import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class Phrase extends Component {
    constructor(props) {
        super(props);

        this.ref = React.createRef();
    }

    componentDidMount() {
        setTimeout(() => {
            this.ref.current.style.opacity = "1";
            this.ref.current.style.marginTop = "5px";
        }, 10);
    }

    render(){
        let audio;
        if(this.props.phrase.audio) {
            audio = this.props.phrase.audio;
        } else {
            audio = "設定なし";
        }
        return(
            <Body ref={this.ref} active={this.props.active}>
                <Controls>
                    <Button onClick={this.props.onClickEdit}><i className="fas fa-pen" /></Button>
                    <Button onClick={this.props.onClickDelete}><i className="fas fa-trash" /></Button>
                </Controls>
                <Separate>
                    <Order>
                    {this.props.phrase.order+1}
                    </Order>
                    <Contents>
                        <Title style={{fontWeight: "bold"}}>
                            英語
                        </Title>
                        <Text>
                            {this.props.phrase.textEn}
                        </Text>
                        <Title style={{fontWeight: "bold"}}>
                            日本語
                        </Title>
                        <Text>
                            {this.props.phrase.textJp}
                        </Text>
                        <Title>
                            音声ファイル：{audio}
                        </Title>
                        <Check Display={this.props.phrase.check}>
                            <i className="fas fa-check" />
                        </Check>
                    </Contents>
                </Separate>
                <Mask delete={this.props.phrase.deleteFlg}>
                </Mask>
            </Body>
        );
    }
}

export { Phrase };

Phrase.propTypes = {
    phrase: PropTypes.object.isRequired,
    active: PropTypes.bool.isRequired,
    onClickEdit: PropTypes.func.isRequired,
    onClickDelete: PropTypes.func.isRequired,
};

const Body = styled.div`
    width: 80%;
    max-width: 250px;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    padding: 10px;
    margin: 5px;
    background-color: #fff;
    box-shadow: 0 0 6px ${props => props.active ? "rgba(255, 0, 165, 1)" : props.select ? "rgba(0, 128, 255, 1)" : "rgba(0, 0, 0, 0.2)"};

    margin-top: 0px;
    opacity: 0;
    transition-duration: 0.2s;

    position: relative;
`;
const Separate = styled.div`
    display: flex;
`;
const Contents = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
`;
const Order = styled.div`
    background-color: #888;
    color: #fff;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    text-align: center;
    margin-right: 5px;
`;
const Title = styled.div`
    font-size: 14px;
`;
const Text = styled.div`
    margin-left: 5px;
`;

const Controls = styled.div`
    position: absolute;
    top: 10px;
    right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
`;
const Button = styled.div`
    margin: 0 5px;
    cursor: pointer;
    color: #888;
`;
const Check = styled.div`
    display: ${props => props.Display ? '' : 'none'};
    position: absolute;
    bottom: 5px;
    right: 10px;
    color: #26CFA9;
    font-size: 32px;
    opacity: 0.6;
`;
const Mask = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #000;
    opacity: ${props => props.delete ? "0.2" : "0"};
    pointer-events: none;
`;